import { Box } from "@mui/material";
import { useJobDetailsContext } from "../../contexts/JobDetailsContext";
import { useAuth } from "../../contexts/AuthContext";
import { OpsJobActions } from "./OpsJobActions";
import { isAdmin } from '../../utils/userPermissions';
import { JobFilesSection } from "./JobFilesSection";
import { JobResultsSection } from "./JobResultsSection";
import { JobTimelineSection } from "./JobTimelineSection";

export function OpsJobDetailsView() {
  const {
    job,
    uploadedFileItems,
    processingArtifactItems,
    isLoadingProcessingResults,
    processingResultsError,
    processingArtifactsRef,
    opsActions,
    fileActions,
    onUploadedFileDelete,
    onProcessingArtifactDelete,
    onUploadClick,
    onProcessingResultUpload,
    getProcessingResultFileUrl,
    onArtifactUpdate,
  } = useJobDetailsContext();

  const { user } = useAuth();
  const isReviewer = user?.role === "reviewer";

  if (!job) return null;
  return (
    <Box sx={{ flex: 1, overflow: "auto" }}>
      <Box sx={{ p: 3, display: "flex", flexDirection: "column", gap: 3 }}>
        {/* Ops-specific assignment and ETA management */}
        <OpsJobActions
          job={job}
          isEditingEta={opsActions.isEditingEta}
          etaValue={opsActions.etaValue}
          onAssignmentClick={opsActions.handleAssignmentClick}
          onEtaEditClick={opsActions.handleEtaEditClick}
          onEtaSave={opsActions.handleEtaSave}
          onEtaCancel={opsActions.handleEtaCancel}
          onEtaValueChange={opsActions.handleEtaValueChange}
          isEtaUpdatePending={opsActions.isEtaUpdatePending}
          showEngagementPidEdit={isAdmin(user?.role || '')}
          isEditingEngagementPid={opsActions.isEditingEngagementPid}
          engagementPidValue={opsActions.engagementPidValue}
          onEngagementPidEditClick={opsActions.handleEngagementPidEditClick}
          onEngagementPidSave={opsActions.handleEngagementPidSave}
          onEngagementPidCancel={opsActions.handleEngagementPidCancel}
          onEngagementPidValueChange={opsActions.handleEngagementPidValueChange}
          isEngagementPidUpdatePending={opsActions.isEngagementPidUpdatePending}
        />

        {/* Files Section */}
        <JobFilesSection
          job={job}
          context="ops"
          uploadedFileItems={uploadedFileItems}
          onUploadClick={onUploadClick}
          onFileDownload={fileActions.handleDownload}
          onFilePreview={(file, index, files) =>
            fileActions.handlePreview(file, files, index)
          }
          onFileDelete={onUploadedFileDelete}
          onUpdateFileType={fileActions.handleUpdateFileType}
          onUpdateBucket={fileActions.handleUpdateBucket}
          onStartProcessing={opsActions.handleStartProcessing}
          isStartProcessingPending={opsActions.isStartProcessingPending}
        />

        {/* Timeline Section - Hidden for reviewers */}
        {!isReviewer && <JobTimelineSection job={job} context="ops" />}

        {/* Results Section with ops-specific features */}
        <JobResultsSection
          job={job}
          context="ops"
          processingArtifactItems={processingArtifactItems}
          isLoadingProcessingResults={isLoadingProcessingResults}
          processingResultsError={processingResultsError}
          processingArtifactsRef={processingArtifactsRef}
          onUploadClick={() => {
            // Trigger the upload from ProcessingArtifacts component
            processingArtifactsRef.current?.triggerUpload();
          }}
          onArtifactDownload={fileActions.handleDownload}
          onArtifactPreview={(file, index, files) =>
            fileActions.handlePreview(file, files, index)
          }
          onArtifactDelete={onProcessingArtifactDelete}
          onProcessingResultUpload={onProcessingResultUpload}
          getProcessingResultFileUrl={getProcessingResultFileUrl}
          onArtifactUpdate={onArtifactUpdate}
          uploadedFileItems={uploadedFileItems}
        />
      </Box>
    </Box>
  );
}
